<template>
  <div class="card2 carousel-card">
    <!-- <a class="link text-decoration-none" :href="visitUrl" target="_blank" > -->
    <img class="image w-100" alt="Logo Images" v-lazy="require(`@/assets/logos/${image}`)" />
    <!--</a> -->
  </div>
</template>
<script>
export default {
  name: "Logocard",
  props: ["image", "visitUrl"],
};
</script>
<style scoped>
.card2 {
  border-radius: 2px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  padding: 0.5rem;
  width: 16rem;
  height: 10rem;
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
.card2:hover {
  transform: scale(1.1);
  transition: transform 0.3s;
}
@media (max-width: 700px) {
  .carousel-card {
    /* transform: translateX(17%);*/
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
  }
}
</style>